import React, { useEffect, useState } from "react"
import MetaTags from "react-meta-tags"
import { Container, Card, CardBody, Row, Col } from "reactstrap"
import { AvField, AvForm } from "availity-reactstrap-validation"
import FileUpload from "components/Common/file-upload/file-upload.component"
import { adminPrefix } from "configs/routePrefix"
import { toast } from "react-toastify"
import { SuccessOk, SuccessCreated } from "configs/statusCode"
import CancelModal from "components/CancelModal"
import SalesRepsService from "services/Admin/SalesRepsService"
import CompoundService from "services/Admin/CompoundService"
import BuildingService from "services/Admin/BuildingService"
import PropertyService from "services/Admin/PropertyService"
import DealService from "services/Admin/DealService"
import LeadService from "services/Admin/LeadService"
import CustomSelect from "../Select"
import SelectOptions from "../SelectOption"
import Select from "react-select"
import SuccessModal from "components/SucessModal"
import { unitTypeOptions } from "Enums/fixedData"
import ResaleService from "services/Admin/ResaleService"

const EditLeadPage = (props) => {
    const id = props.match.params.id
    const dealService = new DealService()
    const leadService = new LeadService()
    const salesRepsService = new SalesRepsService()
    const buildingService = new BuildingService()
    const propertyService = new PropertyService()
    const resaleService = new ResaleService()
    const compoundService= new CompoundService()
    const [formState, setFormState] = useState({})
    const [modal, setModal] = useState(false)
    const [successModal, setSuccessModal] = useState(false)
    const [salesRepOptions, setSalesRepOptions] = useState([])
    const [CompoundOptions, setCompoundptions] = useState([])
    const [buildingOptions, setBuildingOptions] = useState([])
    const [propertyOptions, setPropertyOptions] = useState([])
    const [leadsOptions, setLeadOptions] = useState([])
    const [unitType, setUnitType] = useState('')
    const [resaleOption, setResaleOption] = useState([])
    const [loading, setLoading] = useState(false)
    const [leadId, setLeadId] = useState("")

    const [validate, setValidate] = useState({
        sales_rep_id: null,
        selectedCompound: null,
        selectedProperty: null,
        selectedLead: null,
        unitType: null
    })

    useEffect(() => {
        const id = formState?.selectedBulding ?.value
        handlePropertyService(id)
    }, [formState.selectedBulding])

    useEffect(() => {
        const id = formState?.selectedCompound ?.value
        if(formState?.unitType?.label ==="Property in Compound"){
            handlePropertyService(id)
        } else if(formState?.unitType?.label ==="Resale in Compound"){
            if (id) {
                resaleService.getResaleInCompoundDropDown(id).then(res => {
                const newOptions = res.data?.map(item => {
                    return {
                        label: item.name.en,
                        value: item.id
                    }
                })
                setResaleOption(newOptions)
            }   )
            }
        }
    }, [formState.selectedCompound, formState.unitType])

    useEffect(() => {
        if(formState?.unitType?.label === "Resale Unit Outside Compound"){
            resaleService.getIndependentResaleDropDown().then(res => {
                const newOptions = res.data.map(item => {
                    return {
                         label: item.name.en ?item.name.en :item.name,
                         value: item.id
                     }
                })
                setResaleOption(newOptions)
            })
        }
        if(formState?.unitType?.label === "Resale in Compound"){
            compoundService.getCompoundWithResaleDropDown().then(res => {
                const newOptions = res.data.map(item => {
                    return {
                         label: item.name.en ?item.name.en :item.name,
                         value: item.id
                     }
                })
                setCompoundptions(newOptions)
                setResaleOption([])
            })
        }
        if(formState?.unitType?.label ==="Property in Compound"){
            setCompoundptions([])
        }
    }, [formState.unitType])
    
    useEffect(() => {
        dealService.find(id).then((res) => {
            if (res && res.status === SuccessOk) {
                const data = res.data
                if(!!data?.other){
                    setFormState({
                        unitType: {label: 'Other'},
                        resale_name: data?.other,
                        title: data.title,
                        description: data.description,
                        selectedLead: {
                            label: `${data?.lead_id} / ${data.client?.name}`,
                            value: data?.lead_id
                        },
                        sales_rep_id: {
                            label: `${data.sales_rep?.id} / ${data.sales_rep?.name}`,
                            value: data.sales_rep?.id
                        },
                    })
                    setUnitType({label: 'Other'})
                }else if(!!data?.unit?.building?.id || (!!data?.unit?.compound?.name?.en && !!data?.unit?.name?.en)){
                    setFormState({
                        unitType: {label: 'Property in Compound'},
                        selectedBulding: data.unit?.building?.id ? {
                            label: data.unit?.building?.name?.en,
                            value: data.unit?.building?.id,
                        } : null,
                        selectedCompound: {
                            label: data.unit.compound.name.en,
                            value: data.unit.compound.id,
                        },
                        selectedProperty: {
                            label: data.unit.name.en,
                            value: data.unit.id,
                        },
                        title: data.title,
                        description: data.description,
                        selectedLead: {
                            label: `${data?.lead_id} / ${data.client?.name}`,
                            value: data?.lead_id
                        },
                        sales_rep_id: {
                            label: `${data.sales_rep?.id} / ${data.sales_rep?.name}`,
                            value: data.sales_rep?.id
                        },
                    })
                } else if(!data?.unit && !!data?.resale?.compound?.name?.en && !!data?.resale?.name?.en){
                    setFormState({
                        unitType: {label: 'Resale in Compound'},
                        selectedCompound: {
                            label: data.resale.compound.name.en,
                            value: data.resale.compound.id,
                        },
                        selectedResale: {
                            label: data.resale.name.en,
                            value: data.resale.id,
                        },
                        title: data.title,
                        description: data.description,
                        selectedLead: {
                            label: `${data?.lead_id} / ${data.client?.name}`,
                            value: data?.lead_id
                        },
                        sales_rep_id: {
                            label: `${data.sales_rep?.id} / ${data.sales_rep?.name}`,
                            value: data.sales_rep?.id
                        },
                    })
                    setUnitType({label: 'Resale in Compound'})
                } else {
                    setFormState({
                        unitType: {label: 'Resale Unit Outside Compound'},
                        selectedResale: {
                            label: data.resale?.name?.en,
                            value: data.resale?.id,
                        },
                        title: data.title,
                        description: data.description,
                        selectedLead: {
                            label: `${data?.lead_id} / ${data.client?.name}`,
                            value: data?.lead_id
                        },
                        sales_rep_id: {
                            label: `${data.sales_rep?.id} / ${data.sales_rep?.name}`,
                            value: data.sales_rep?.id
                        },
                    })
                    setUnitType({label: 'Resale Unit Outside Compound'})
                }
                setLeadId(res.data.lead_id)
            }
        })
    }, [id])
    
    useEffect(() => {
        const id = formState ?.selectedCompound ?.value
         if (id && formState.unitType.label === "Property in Compound") {
            buildingService.getDropDown(id).then(res => {
                const newOptions = res.data.map(item => {
                    return {
                        label: item.name.en,
                        value: item.id
                    }
                })
                setBuildingOptions(newOptions)
            })
        }
        
    }, [formState.selectedCompound])

    // useEffect(() => {
    //     const id = formState ?.selectedCompound ?.value
    //       if (id) {
    //         propertyService.getDropDownCustom(id).then(res => {
    //             const newOptions = res.data.map(item => {
    //                 return {
    //                     label: item.name.en,
    //                     value: item.id
    //                 }
    //             })
    //             setPropertyOptions(newOptions)
    //         })
    //     }
        
    // }, [formState.selectedCompound])

    useEffect(() => {
        salesRepsService.getDropDown().then(res => {
            const newOptions = res.data.map(item => {
                return {
                    label: item.name.en ? item.name.en : item.name,
                    value: item.id
                }
            })

            setSalesRepOptions(newOptions)
        })

        leadService.getDropDown().then(res => {
            const newOptions = res.data.map(item => {
                return {
                    label: `${item.id} / ${item.name}`,
                    value: item.id
                }
            })
            let selectedOwner= newOptions.find(option=>parseInt(option.value)===parseInt(leadId))
            // setFormState((formState)=>({ ...formState, selectedLead:  selectedOwner}))
            setLeadOptions(newOptions)
        })
    }, [])

    const handlePropertyService= (pro_id)=>{
           if (pro_id) {
            propertyService.getDropDown(pro_id).then(res => {
                const newOptions = res.data.map(item => {
                    return {
                        label: item.name.en,
                        value: item.id
                    }
                })
                setPropertyOptions(newOptions)
            })
        }
    }
    
    const handleValidSubmit = (e, v) => {

        if ((formState?.unitType?.label === "Property in Compound" && !formState.selectedCompound) || 
            (formState?.unitType?.label === "Property in Compound" && !formState.selectedProperty)) {
            if(!formState.selectedCompound){
                toast.error("please select Compound")
                return 
            }
            if (!formState.selectedProperty){
                toast.error("please select Property")
                return
            }
        } else if (
                (formState?.unitType?.label === "Resale in Compound" && !formState.selectedCompound) || 
                (formState?.unitType?.label === "Resale in Compound" && !formState.selectedResale)) {
            if(!formState.selectedCompound){
                toast.error("please select Compound")
                return 
            }
            if (!formState.selectedResale){
                toast.error("please select Resale")
                return
            }
        } else if ((formState?.unitType?.label === "Resale Unit Outside Compound" && !formState.selectedResale)) {
            toast.error("please select Resale")
            return
        } else if ((formState?.unitType?.label === "other" && !formState.resale_name)) {
                toast.error("Please Enter Resale Name")
                return
        } else {
            setLoading(true)
            let info;
            if(formState?.unitType?.label === "Property in Compound"){
                info = {
                    compound_id: formState?.selectedCompound?.value,
                    building_id: formState?.selectedBulding?.value,
                    unit_id: formState.selectedProperty.value,
                    resale_id: null,
                    other: null
                }
            } else if(formState?.unitType?.label === "Resale in Compound"){
                info = {
                    compound_id: formState?.selectedCompound?.value,
                    resale_id: formState.selectedResale.value,
                    unit_id: null,
                    other: null
                }
            } else if(formState?.unitType?.label === "Resale Unit Outside Compound"){
                info = {
                    resale_id: formState.selectedResale.value,
                    unit_id: null,
                    other: null
                }
            } else{
                info = {
                    other: formState.resale_name,
                    resale_id: null,
                    unit_id: null
                }
            }
            const data = {
                    ...info,
                    title: formState.title,
                    description: formState.description,
                    lead_id: formState.selectedLead.value,
                    sales_rep_id: formState.sales_rep_id.value,   
                }

            dealService.update(id,data).then(response => {
                if (response && response.status === SuccessOk) {
                    setSuccessModal(true)
                }
                setLoading(false)
            })
        }

    }

    const handleFieldChange = (e) => {
        setFormState({ ...formState, [e.target.name]: e.target.value })
    }

    return (
        <React.Fragment>
            <div className='page-content'>
                <MetaTags>
                    <title>Edit Deal</title>
                </MetaTags>
                <Container fluid>
                    <h4>
                        {/* <button className="p-0 m-0 border-0 bg-light"
                            onClick={() => {
                                setModal(true)
                            }}>
                            <i className="fa fa-arrow-left text-primary me-2"></i>
                        </button> */}
                        Edit Deal
                    </h4>
                    <AvForm
                        className='form-horizontal'
                        onValidSubmit={(e, v) => {
                            handleValidSubmit(e, v)
                        }}>
                        <Card className="w-100 mt-4">
                            <CardBody>
                                <Row className="mb-4">
                                    <Col md={6}>
                                        <div className='mt-2'>
                                            <AvField
                                                name='title'
                                                label="Deal Title"
                                                className='form-control'
                                                placeholder='Type Deal Title'
                                                errorMessage="This Field is Required"
                                                required
                                                onChange={(e) => handleFieldChange(e)}
                                                bsSize="lg"
                                                value={formState.title}
                                            />
                                        </div>
                                    </Col>
                                    <CustomSelect
                                        label={"Client Name"}
                                        className="mt-2"
                                        id={"leadOptions"}
                                        options={leadsOptions}
                                        selected={formState.selectedLead}
                                        validate={validate.selectedLead}
                                        setOptions={(options) => setLeadOptions(options)}
                                        setFormState={(data) => {
                                            setFormState({ ...formState, selectedLead: data })

                                        }} />
                                           <CustomSelect
                                           id={"salesRepOptions"}
                                           className="mt-2"
                                            label={"Sales Rep"}
                                            placeholder='Select'
                                            options={salesRepOptions} 
                                            selected={formState.sales_rep_id}
                                            validate={validate.sales_rep_id}
                                            setOptions={options => setSalesRepOptions(options)}
                                            setFormState={(data) => {
                                                setFormState({ ...formState, sales_rep_id: data })
                                            }}
                                        />  
                                    <CustomSelect
                                        id={"unitType"}
                                        label={"Select Unit Type"}
                                        options={unitTypeOptions}
                                        className="mt-2"
                                        validate={validate.unitType}
                                        selected={formState.unitType}
                                        setOptions={options => setUnitType(options)}
                                        setFormState={(data) => {
                                            if(data?.label ==="Property in Compound" || data?.label ==="Resale in Compound"){
                                                setFormState({ ...formState, unitType: data, selectedCompound: null, })
                                            } else if(data?.label ==="Resale Unit Outside Compound") {
                                                setFormState({ ...formState, unitType: data, selectedResale: null, })
                                            } else {
                                                setFormState({ ...formState, unitType: data, selectedCompound: null, selectedResale: null, })
                                            }

                                        }}
                                    />
                                    {!!formState.unitType && formState.unitType.label ==="Property in Compound" && <>
                                    <SelectOptions
                                            Service={CompoundService}
                                            id={"CompoundOptions"}
                                            className="mt-2"
                                            label={"Compound"}
                                            options={CompoundOptions}
                                            selected={formState.selectedCompound}
                                            setOptions={options => setCompoundptions(options)}
                                            setFormState={(data) => {
                                                setFormState({ ...formState, selectedCompound: data, selectedBulding: null, selectedProperty:null })

                                            }}
                                        />
                                    <Col md={6} className="mt-2">
                                        <label>Building</label>
                                        <Select
                                            placeholder='Select'
                                            options={buildingOptions}
                                            onChange={data => setFormState({ ...formState, selectedBulding: data, selectedProperty: null })}
                                            value={formState.selectedBulding}
                                            setOptions={options => setBuildingOptions(options)}
                                        />
                                    </Col>
                                    <CustomSelect
                                        id={"propertyOptions"}
                                        className="mt-2"
                                        label={"Property"}
                                        options={propertyOptions}
                                        selected={formState.selectedProperty}
                                        setOptions={options => setPropertyOptions(options)}
                                        setFormState={(data) => {
                                            setFormState({ ...formState, selectedProperty: data })
                                        }} />
                                    </>}
                                    {!!formState.unitType && formState.unitType.label ==="Resale in Compound" && <>
                                    <SelectOptions
                                            Service={CompoundService}
                                            className="mt-2"
                                            id={"CompoundOptions"}
                                            label={"Compound"}
                                            options={CompoundOptions}
                                            selected={formState.selectedCompound}
                                            setOptions={options => setCompoundptions(options)}
                                            setFormState={(data) => {
                                                setFormState({ ...formState, selectedCompound: data, selectedResale: null })
                                            }}
                                        />
                                    <Col md={6} className="mt-2">
                                        <label>Resale</label>
                                        <Select
                                            placeholder='Select'
                                            options={resaleOption}
                                            onChange={data => setFormState({ ...formState, selectedResale: data })}
                                            value={formState.selectedResale}
                                        />
                                    </Col>
                                    </>}
                                    {!!formState.unitType && formState.unitType.label ==="Resale Unit Outside Compound" && <>
                                    <Col md={6} className="mt-2">
                                        <label>Resale</label>
                                        <Select
                                            placeholder='Select'
                                            options={resaleOption}
                                            onChange={data => setFormState({ ...formState, selectedResale: data })}
                                            value={formState.selectedResale}
                                        />
                                    </Col>
                                    </>}
                                    {!!formState.unitType && formState.unitType.label ==="Other" && <>
                                    <Col md={6} className="mt-2">
                                        <AvField
                                                name='resale_name'
                                                label="Resale Name"
                                                placeholder='Resale Name'
                                                className='form-control'
                                                type="text"
                                                onChange={(e) => handleFieldChange(e)}
                                                bsSize="lg"
                                                value={formState.resale_name}
                                            />
                                    </Col>
                                    </>}
                                    <Col md={12}>
                                        <div className='mt-2'>
                                            <AvField
                                                name='description'
                                                label="Description"
                                                placeholder='Type Description'
                                                className='form-control'
                                                type="textarea"
                                                onChange={(e) => handleFieldChange(e)}
                                                bsSize="lg"
                                                value={formState.description}
                                            />
                                        </div>
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>
                        <Row className="d-flex justify-content-between pb-4">
                            <Col>
                                <button
                                    type="button"
                                    className="btn btn-light btnHeight px-4"
                                    onClick={() => {
                                        setModal(true)
                                    }}
                                    size={"lg"}>
                                    Cancel
                                </button>
                            </Col>
                            <Col>
                                <button
                                    type='submit'
                                    className="btn btn-success btnHeight px-4 float-end"
                                    size={"lg"}
                                    disabled={loading ? true : false}
                                    onClick={() => {
                                        let obj = {}
                                        for (let key in validate) {
                                            if (formState[key]) {
                                                obj[key] = false
                                            } else {
                                                obj[key] = true
                                            }
                                        }
                                        setValidate({ ...obj })
                                    }}
                                >
                                    Submit
                                 </button>
                            </Col>
                        </Row>
                        <CancelModal modal={modal}
                            setModal={setModal}
                            goBackHandler={() => props.history.goBack()}
                        />
                    </AvForm>
                    <SuccessModal
                        modal={successModal}
                        message={"Edited Deal Successfully"}
                        onClick={() => {
                            props.history.goBack()
                        }}
                        title={"Edit Deal"}
                    />
                </Container>
            </div>
        </React.Fragment>
    )
}

export default EditLeadPage
